var m = require('mithril');
var prop = require('mithril/stream')
var key = require('../../libs/keybindings');
var loaders = require('../../layout/components/loaders');
var modal = require('../../layout/components/modal');
var Column = require('../models/column');
var fieldnetTree = require('../../network/components/fieldnetTree');
var Model = require('../../libs/Model')
var formGroup = require('../../components/formGroup');

var column = Object.create(Column);

function urlForRecord (record) {
  return '/api/v1/' + record['@class'].toLowerCase() + '/' + record['@rid'].slice(1);
}

column.initForm = function (record, options) {
  var normalizedRecord = Object.assign({}, record || {});

  column.columnNameRequired = Boolean(options && options.columnNameRequired);
  column.hideNameInput = Boolean(
    (options && options.onlyTree && !column.columnNameRequired) ||
    (options && options.columnName && !column.columnNameRequired)
  );
  column.onlyTree = Boolean(options && options.onlyTree);
  column.ignoreRouteSelection = Boolean(options && options.ignoreRouteSelection);

  if ((typeof normalizedRecord.in === 'object') && normalizedRecord.in['@rid']) {
    normalizedRecord.in = normalizedRecord.in['@rid'];
  }

  if (options && options.columnName) {
    normalizedRecord.name = normalizedRecord.name || options.columnName;
    column.columnName = options.columnName;
  } else {
    column.columnName = null;
  }

  return Model.initForm.call(column, normalizedRecord);
};

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
})

column.editDialogue = function (record, options) {
  column.initForm(record, options);
  var submit = function () {
    var savedData;
    return column.save()
    .then(function (data) {
      savedData = data;
      return options && typeof options.submitCallback === 'function' ? options.submitCallback(data) : undefined;
    })
    .then(function () {
      key.unbind('enter');
      modal.vm.close();
      m.redraw();
      return savedData;
    })
  };

  key.setScope('modal');
  key('enter', 'modal', submit);

  // if (record['@rid']) {
  //   loaders.requestWithLoader({
  //     loader: 'background',
  //     url: urlForRecord(record),
  //     method: 'GET'
  //   })
  //   .then(function (res) {
  //     column.tree.vm.selectNode(urlForRecord(res.source));
  //   })
  // }

  modal.vm.title(record['@rid'] ? "Edit Binding" : "Connect to Point");
  modal.vm.body = column.onlyTree ? column.treeOnlyView : column.view;
  modal.vm.buttons([
    {
      label: "Submit",
      class: "dib",
      func: submit
    },
  ])

  if (record['@rid']) {
    modal.vm.buttons().unshift({
      label: "Delete",
      class: "dib red mr2",
      func: column.deleteDialogue.bind(column, record, options)
    })
  }

  modal.vm.open()
};

function nameInputView () {
  if (column.hideNameInput) {
    return [];
  }

  return [
    m('name', {for:'pd-name'}, 'Name'),
    m('input.form-control', {
      id:'pd-name',
      type:'text',
      autocomplete: 'off',
      oninput: (ev) => column.form.name(ev.target.value),
      value: column.form.name(),
    }),
  ];
}

column.deleteDialogue = function (record, options) {
  var submit = function () {
    var callbackResult;
    return column.delete(record)
    .then( function (data) {
      key.unbind('enter');
      callbackResult = options && typeof options.submitCallback === 'function' ? options.submitCallback(data) : undefined;
      return Promise.resolve(callbackResult);
    })
    .then(function () {
      modal.vm.close();
      m.redraw();
      return true;
    })
  };

  key.unbind('enter');
  key.setScope('modal');
  key('enter', 'modal', submit);

  column.initForm(record, options);

  modal.vm.title('Delete ' + record.name + '?');
  modal.vm.buttons([
    {
      label: "Submit",
      class: "dib",
      func: submit
    }
  ])
  modal.vm.body = prop(false);
  modal.vm.open();
};

column.view = function () {
  return m('form.form-dark', {role:'form'}, [
    column.errorView(),
    m('div.form-group.flex.flex-wrap.mb3', [
      column.record.path && column.record.path.length > 0 ? 
        column.record.path.map(function (pathRecord, idx) {
          return m('div', {key: pathRecord['@rid'], class: 'mr2 flex'}, [
            m('span.mr2.nowrap', pathRecord.name == 'root' ? 'Home' : pathRecord.name || pathRecord['@class']),
            idx < column.record.path.length - 1 ?
              m('span', ' / ')
              : ''
          ]);
        }) : '',
    ]),
    m(formGroup, [
      nameInputView(),
      (()=>{
        if(!column.onlyTree){
          return [
            m("name", {for:"chart-type-input"}, "Chart Type"),
            m("select.form-control", {
              onchange: (ev) => column.form.chartType(ev.target.value),
              value: column.form.chartType(),
            }, [
              m("option", {value:"line"}, "Line"),
              m("option", {value:"spline"}, "Spline"),
              m("option", {value:"area"}, "Area"),
              m("option", {value:"area-spline"}, "Area Spline"),
              m("option", {value:"step"}, "Step"),
              m("option", {value:"bar"}, "Bar"),
            ]),
            m('name', {for:'pd-min'}, 'Min'),
            m('input.form-control', {
              id:'pd-min',
              type:'number',
              autocomplete: 'off',
              onchange: (ev) => column.form.min(ev.target.value),
              value: column.form.min(),
            }),
            m('name', {for:'pd-max'}, 'Max'),
            m('input.form-control', {
              id:'pd-max',
              type:'number',
              autocomplete: 'off',
              onchange: (ev) => column.form.max(ev.target.value),
              value: column.form.max(),
            }),
            m('name', {for:'pd-scale'}, 'Scale'),
            m('input.form-control', {
              id:'pd-scale',
              type:'number',
              autocomplete: 'off',
              onchange: (ev) => column.form.scale(ev.target.value),
              value: column.form.scale(),
            }),
            // m("name", {for:"chart-type-input"}, "Component Type"),
            // m("select.form-control", {
            //   onchange: (ev) => column.form.graphicComponent(ev.target.value),
            //   value: column.form.graphicComponent(),
            // }, [
            //   m("option", {value:"fan"}, "Fan"),
            //   m("option", {value:"box"}, "Box"),
            //   m("option", {value:"text"}, "Text")
            // ])
          ]
        }
      })(),
      m(fieldnetTree, {
        selectedPoint: column.form.in,
        ignoreRouteSelection: column.ignoreRouteSelection
      }),
    ]),
    
  ])
}

column.treeOnlyView = function () {
  return m('form.form-dark', {role:'form'}, [
    column.errorView(),
    m('div.form-group.flex.flex-wrap.mb3', [
      column.record.path && column.record.path.length > 0 ?
        column.record.path.map(function (pathRecord, idx) {
          return m('div', {key: pathRecord['@rid'], class: 'mr2 flex'}, [
            m('span.mr2.nowrap', pathRecord.name == 'root' ? 'Home' : pathRecord.name || pathRecord['@class']),
            idx < column.record.path.length - 1 ?
              m('span', ' / ')
              : ''
          ]);
        }) : '',
    ]),
    m(formGroup, [
      nameInputView(),
      m(fieldnetTree, {
        selectedPoint: column.form.in,
        ignoreRouteSelection: column.ignoreRouteSelection
      }),
    ]),
  ])
}

module.exports = column;
